import { Link } from "react-router-dom";
import { useTranslation } from "@/contexts/LanguageContext";
import { useAdminOnline } from "@/hooks/useAdminOnline";

export default function AiBanner() {
  const { t } = useTranslation();
  const adminOnline = useAdminOnline();

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-foreground/5 backdrop-blur-sm border-b border-foreground/10">
      <div className="container mx-auto flex items-center justify-center gap-2 py-1.5 px-4">
        <span
          className={`w-2 h-2 rounded-full shrink-0 ${
            adminOnline
              ? "bg-amber-400"
              : "bg-emerald-400 animate-[pulse-led_2s_ease-in-out_infinite]"
          }`}
        />
        <span className="text-xs font-medium text-foreground tracking-wide">
          {adminOnline ? t("banner.human") : t("banner.autonomous")}
        </span>
        <span aria-hidden className="w-1 h-1 rounded-full bg-muted-foreground/30 shrink-0" />
        <Link
          to="/ai"
          className="text-xs font-medium text-muted-foreground tracking-wide hover:text-foreground transition-colors"
        >
          Learn more
        </Link>
      </div>
    </div>
  );
}
